import React from "react";
import { Tooltip, TooltipButton, GlyphInfo } from "@americanexpress/dls-react";

const LabelTooltip = ({ tooltipText }) => (
  <span className="infoTooltip">
    <Tooltip
      id="tooltip-default-top"
      triggerElement={<TooltipButton className="pad-0" icon={<GlyphInfo />} tabIndex="-1" />}
      placement="left"
    >
      <div>{tooltipText}</div>
    </Tooltip>
  </span>
);

export default LabelTooltip;  